import React from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import './Markdown.scss';

const renderer = new marked.Renderer();

export const Markdown = ({
    markdown
}: {
    markdown: string;
}) => {
    const html = React.useMemo(() => {
        const markedHtml = marked(markdown, {
            mangle: false,
            headerIds: false,
            renderer,
            breaks: true,
            gfm: true,
            async: false,
            pedantic: false,
            sanitize: false
        }) as string;

        // Decode HTML entities that marked/DOMPurify double-encode
        const decodedHtml = markedHtml
            .replace(/&amp;lt;/g, '&lt;')
            .replace(/&amp;gt;/g, '&gt;')
            .replace(/&amp;amp;/g, '&amp;');

        return DOMPurify.sanitize(decodedHtml, {
            RETURN_DOM_FRAGMENT: false,
            RETURN_DOM: false,
            KEEP_CONTENT: true,
            ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'code', 'pre', 'blockquote', 'a', 'img', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'hr', 'del', 'ins', 'sup', 'sub', 'div', 'span'],
            ADD_ATTR: ['target', 'href', 'src', 'alt', 'title', 'class']
        });
    }, [markdown]);

    return (
        <div className="marked" dangerouslySetInnerHTML={{ __html: html }} />
    )
}